import { gql } from '@apollo/client'

export const FETCH_BUNDLE = gql`
  query bundle($id: ID!) {
    node(id: $id) {
      ... on Bundle {
        id
        identifier
        commercialName
        startDate
        endDate
        computedStatus
        bundleSchedules {
          status
          audience
          startDate
          endDate
          consumedAt
          freedAt
        }
        media {
          id
          asId
          address
          building {
            name
          }
          agglomeration {
            name
          }
          city {
            name
          }
        }
      }
    }
  }
`
